(function () {
    const BLOCKS = document.querySelectorAll('.collapse-repeater-support');

    function closeAll(block) {
        block.querySelectorAll('.item-head.-active').forEach(h => h.classList.remove('-active'));
        block.querySelectorAll('.item-content').forEach(c => {
            c.classList.remove('-active');
            c.style.maxHeight = null;
        });
    }

    function open(head, doScroll) {
        const content = head.nextElementSibling;
        head.classList.add('-active');
        content.classList.add('-active');
        content.style.maxHeight = content.scrollHeight + 'px';

        if (doScroll) {
            const y = head.getBoundingClientRect().top + window.scrollY - 200;
            window.scrollTo({ top: y, left: 0, behavior: 'auto' });
        }
    }

    BLOCKS.forEach(block => {
        block.addEventListener('click', (e) => {
            const head = e.target.closest('.item-head');
            if (!head || !block.contains(head)) return;

            const isActive = head.classList.contains('-active');
            closeAll(block);
            if (!isActive) open(head, false);
        });

        const presetActive = block.querySelector('.item-head.-active');
        closeAll(block);
        if (presetActive) open(presetActive, false);
    });

    const rawHash = location.hash ? location.hash.slice(1) : '';
    if (rawHash) {
        const safeHash = (window.CSS && CSS.escape) ? CSS.escape(rawHash) : rawHash;
        const targetItem = document.querySelector(`.collapse-repeater-support .item[data-id="${safeHash}"]`);
        if (targetItem) {
            const block = targetItem.closest('.collapse-repeater-support');
            const head = targetItem.querySelector('.item-head');
            if (block && head) {
                closeAll(block);
                open(head, true);
            }
        }
    }

    let t;
    window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => {
            document.querySelectorAll('.collapse-repeater-support .item-content.-active').forEach(c => {
                c.style.maxHeight = c.scrollHeight + 'px';
            });
        }, 150);
    });
})();